export default "__VITE_ASSET__HAjpQeUP__"